<template>
  <div :class="['grid-block', borderClass]">
    <div
      class="grid-content"
      v-html="grid"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  grid: { type: String, required: true },
  border: { type: String, default: null }
})

const borderClass = computed(() => {
  if (props.border === 'top') return 'border-top'
  if (props.border === 'bottom') return 'border-bottom'
  return ''
})
</script>
